import { useDataTableContext } from '../DataTableContext'
import { NoRecordRowTableComponent } from './NoDataRow'
import { RowTableComponent } from './RowTableComponent'

function RowPart() {
    const {
        paginationData,
        page,
        rowPerPage,
        sortColOrders,
        hasCollapseData,
        ...tableProps
    } = useDataTableContext()

    const {
        itemKey,
        headers,
        selected = [],
        selectMode,
        rowOption,
        onDragDrop,
        RowComponent = RowTableComponent,
        subRowLevel,
    } = tableProps

    if (paginationData.length === 0)
        return <NoRecordRowTableComponent {...tableProps} />

    return (
        <>
            {paginationData.map((item: any, index: number) => (
                <RowComponent
                    key={
                        'row-component-' +
                        (item[itemKey] || page * rowPerPage + index)
                    }
                    groupRowkey={
                        item[itemKey] || (page * rowPerPage + index).toString()
                    }
                    subRowLevel={subRowLevel}
                    {...tableProps}
                    itemKey={itemKey}
                    item={item}
                    childrenItems={item.childrenItems || []}
                    headers={headers}
                    isSelect={selected.includes(item[itemKey])}
                    selectMode={selectMode}
                    rowOption={rowOption}
                    enableDragAndDrop={onDragDrop}
                    index={index}
                    sortColOrders={sortColOrders}
                    hasCollapse={hasCollapseData}
                />
            ))}
        </>
    )
}
export default RowPart
